// src/tagTypes.ts

// Auth tag types
export const API_TAGS = {
  GET_ME: "get-me",
  VENDOR_LIST: "vendors-list",
  SERVICE_TYPES: "service-types",
  INVOICE_LIST: "invoices-list",
  BUSINESS_UNIT_LIST: "business-unit-list",
  DEPARTMENT_LIST: "department-list",
  DASHBOARD: "dashboard",
} as const;
export type TApiTags = (typeof API_TAGS)[keyof typeof API_TAGS];
